import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';
import { useSiteSettings } from '@/context/SiteSettingsContext';
import { Button } from '@/components/ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { settings } = useSiteSettings();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(credentials.username, credentials.password);
      toast.success('Willkommen zurück!');
      navigate('/admin');
    } catch (error) {
      toast.error(error.message || 'Ungültige Anmeldedaten');
    } finally {
      setLoading(false);
    }
  };

  // Get logo URL
  const getLogoUrl = () => {
    if (settings?.admin_logo_light) {
      return settings.admin_logo_light.startsWith('http') 
        ? settings.admin_logo_light 
        : `${API_URL}${settings.admin_logo_light}`;
    }
    return null;
  };

  const logoUrl = getLogoUrl();

  return (
    <div className="min-h-screen bg-[#F9F9F7] flex items-center justify-center px-6 admin-layout">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-10">
          {logoUrl ? (
            <img 
              src={logoUrl} 
              alt="NYZA-STUDIO" 
              className="h-12 mx-auto object-contain"
            />
          ) : (
            <h1 className="text-3xl font-black tracking-tight text-[#0A0A0A]" style={{ fontFamily: "'Poppins', sans-serif" }}>
              NYZA-STUDIO <span className="text-gold">CARDEALER</span>
            </h1>
          )}
          <p className="overline mt-2 text-[#666666]">Admin Portal</p>
        </div>

        {/* Login Form */}
        <div className="bg-white border border-[#E5E5E5] p-8 md:p-10">
          <h2 className="font-heading text-2xl font-light mb-6 text-[#0A0A0A]">Anmelden</h2>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="overline block mb-2">Benutzername</label>
              <input
                type="text"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                className="input-premium w-full"
                placeholder="Benutzername eingeben"
                required
                data-testid="login-username"
              />
            </div>
            <div>
              <div className="flex justify-between items-center mb-2">
                <label className="overline">Passwort</label>
                <Link 
                  to="/admin/forgot-password" 
                  className="text-xs text-gold hover:text-[#B8962E] transition-colors"
                >
                  Passwort vergessen?
                </Link>
              </div>
              <input
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                className="input-premium w-full"
                placeholder="Passwort eingeben"
                required
                data-testid="login-password"
              />
            </div>
            <Button
              type="submit"
              className="btn-primary w-full"
              disabled={loading}
              data-testid="login-submit"
            >
              {loading ? <div className="spinner mx-auto" /> : 'Anmelden'}
            </Button>
          </form>

        </div>
      </div>
    </div>
  );
}
